<template>
    <div style="display:flex">
        <template v-if="propValue.Finance">
            <div ref="chart" style="width: 80%;height: 100%"/>
            <div
                style="font-size: 18px;width: 20%;height: 100%;text-align:left;color:#fff;display: flex;justify-content: flex-start;align-items: flex-end">
                <div style='margin-bottom: 20px; font-size: 26px;font-family: 隶书' v-show='rightInfo.rename'>
                    <li><span style='color: white;'>{{ rightInfo.rename }}详细信息</span></li>
                    <li><span style='color: white; margin-right: 10px'>收款:</span> <span style='color: rgb(2,212,236);'>{{
                            rightInfo.shoukuan
                        }}</span></li>
                    <li><span style='color: white; margin-right: 10px'>合同:</span> <span style='color: rgb(2,212,236);'>{{
                            rightInfo.hetong
                        }}</span>
                    </li>
                    <li><span style='color: white; margin-right: 10px'>人数:</span> <span style='color: rgb(2,212,236);'>{{
                            rightInfo.renshu
                        }}</span>
                    </li>
                    <li><span style='color: white; margin-right: 10px'>费用:</span> <span style='color: rgb(2,212,236);'>{{
                            rightInfo.feiyong
                        }}</span>
                    </li>
                </div>
            </div>
        </template>

        <template v-else>
            <!-- zheng -->
            <div ref="chart" style="width: 100%;height: 100%"/>
        </template>
    </div>
</template>

<script>
// echarts 地图大全 https://www.makeapie.com/explore.html#charts=map~sort=rank~timeframe=all~author=all
import * as echarts from 'echarts'; // echarts 版本5 必须这样引用
import chinaJson from '@/assets/json/china_full.json';
import bei_jing from '@/assets/json/provinces/110000.json';
import tian_jin from '@/assets/json/provinces/120000.json';
import he_bei from '@/assets/json/provinces/130000.json';
import shan_xi from '@/assets/json/provinces/140000.json';
import nei_menggu from '@/assets/json/provinces/150000.json';
import liao_ning from '@/assets/json/provinces/210000.json';
import ji_lin from '@/assets/json/provinces/220000.json';
import hei_longjiang from '@/assets/json/provinces/230000.json';
import shanghai from '@/assets/json/provinces/310000.json';
import jiang_su from '@/assets/json/provinces/320000.json';
import zhe_jiang from '@/assets/json/provinces/330000.json';
import an_hui from '@/assets/json/provinces/340000.json';
import fu_jian from '@/assets/json/provinces/350000.json';
import jiang_xi from '@/assets/json/provinces/360000.json';
import shang_dong from '@/assets/json/provinces/370000.json';
import he_nan from '@/assets/json/provinces/410000.json';
import hu_bei from '@/assets/json/provinces/420000.json';
import hu_nan from '@/assets/json/provinces/430000.json';
import guang_dong from '@/assets/json/provinces/440000.json';
import guang_xi from '@/assets/json/provinces/450000.json';
import hai_nan from '@/assets/json/provinces/460000.json';
import chong_qing from '@/assets/json/provinces/500000.json';
import si_chuang from '@/assets/json/provinces/510000.json';
import gui_zhou from '@/assets/json/provinces/520000.json';
import yu_nan from '@/assets/json/provinces/530000.json';
import xi_zang from '@/assets/json/provinces/540000.json';
import shan3_xi from '@/assets/json/provinces/610000.json';
import gan_su from '@/assets/json/provinces/620000.json';
import qinghai from '@/assets/json/provinces/630000.json';
import ning_xia from '@/assets/json/provinces/640000.json';
import xin_jiang from '@/assets/json/provinces/650000.json';
import tai_wan from '@/assets/json/provinces/710000.json';
import xiang_gang from '@/assets/json/provinces/810000.json';
import ao_men from '@/assets/json/provinces/820000.json';


export default {
    name: 'MapVisual',
    props: {
        propValue: {
            type: Object,
            require: false,
            default() {
                return {};
            },
        },
        element: {
            // 组件的全体内容
            type: Object,
        },
    },
    data() {
        return {
            myChart: {},
            objID: {},
            // 数据的值
            mapData: [
                {name: '海门', value: 200},
                {name: '鄂尔多斯', value: 200},
                {name: '招远', value: 200},
                {name: '舟山', value: 200},
                {name: '齐齐哈尔', value: 300},
                {name: '盐城', value: 100},
                {name: '赤峰', value: 100},
            ],
            // 最直接的散射数据
            scatterData: [],
            // 数据的坐标
            geoCoordMap: {
                海门: [121.15, 31.89],
                鄂尔多斯: [109.781327, 39.608266],
                招远: [120.38, 37.35],
                舟山: [122.207216, 29.985295],
                齐齐哈尔: [123.97, 47.33],
                盐城: [120.13, 33.38],
                赤峰: [118.87, 42.28],
                青岛: [120.33, 36.07],
                乳山: [121.52, 36.89],
                金昌: [102.188043, 38.520089],
                泉州: [118.58, 24.93],
            },
            rightInfo: {
                cityName: '',
                shoukuan: '',
                hetong: '',
                renshu: '',
                feiyong: '',
            },
        };
    },
    mounted() {
        this.registerAllMaps();
        // todo 增加注册全部还是局部地图功能



        this.objID = this.$refs.chart;

        this.myChart = echarts.init(this.objID, null);


        // 财务专用
        if (this.propValue.Finance) {
            // 散点图 淡出
            this.propValue.chartOption.series.forEach((item) => {
                item.emphasis = {
                    // scale: true,
                    focus: 'self',
                    blurScope: 'global',
                    showEffectOn: 'emphasis',
                };
                item.showEffectOn = 'emphasis';
            });
        }

        // 处理 visualMap.seriesIndex
        let seriesIndexString = this.propValue.chartOption.visualMap.seriesIndexString;
        if (!seriesIndexString) {
            this.propValue.chartOption.visualMap.seriesIndex = undefined;
        } else {
            this.propValue.chartOption.visualMap.seriesIndex = seriesIndexString.split(',');
        }

        this.getData();
        // this.myChart.setOption(this.propValue.chartOption, true);

        function randomValue() {
            return Math.round(Math.random()*2000);
        }

        let testOption = {
            tooltip: {},
            visualMap: {
                type: 'piecewise',
                show: true,
                outOfRange: {
                    color: '#fff',
                },
                // 0 代表第一系列
                // numberArray
                // https://echarts.apache.org/zh/option.html#visualMap-piecewise.seriesIndex
                // seriesIndex: 0,
                // 离散
                // dimension: 2,
                pieces: [
                    { gt: 1200, lte: 1400,  },
                    { gt: 1000, lte: 1200,  },
                    { gt: 800, lte: 1000,  },
                    { gt: 600, lte: 800,  },
                    { gt: 400, lte: 600,  }, // (10, 200]
                    // { value: 123, label: '123（自定义特殊颜色）',  } // [123, 123]
                    // { lt: 5 } // (-Infinity, 5)
                ],
                itemSymbol: 'circle',
                textStyle: {
                    color: 'rgba(255,255,255,1)'
                }
            },
            geo: {
                map: 'China',
                roam: true,
                label: {
                    show: false,
                },
                itemStyle: {
                    // 描边颜色
                    borderColor: 'rgba(0,0,0,1)',
                    areaColor: 'rgba(255,255,255,1)',
                }
            },
            series : [
                {
                    name: '123123',
                    seriesName: 'series1',
                    type: 'map',
                    roam: false,
                    coordinateSystem: 'geo',
                    geoIndex: 0,
                    tooltip: {show: true },
                    label: {
                        show: true,
                        normal: {
                            formatter: '{b}{c}',
                            position: 'right',
                            show: false
                        },
                        emphasis: {
                            show: true
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: '#F06C00'
                        }
                    },
                    data:[
                        {name: '江苏省', value: 450},
                        {name: '浙江省', value: 850},
                        {name: '山西省', value: 1100},
                        {name: '安徽省', value: 1100},
                    ]
                }
            ]
        };
        // this.myChart.setOption(testOption, true);

        // 监听地图的点击事件
        // this.myChart.on('click', function (param) {
        //     // console.log(param);
        //     // 点击 省份
        //     if (param.componentType === 'geo') {
        //
        //     }
        //     // 点击 点
        //     if (param.componentType === 'series') {
        //     }
        // });

        this.$nextTick(() => {
            this.drawLine();
        });
    },
    update() {
        console.log('update');
        if (this.element.dataSource === 'billform') {
            this.ifBillForm();
        } else if (this.element.dataSource === 'static') {
            this.ifStatic();
        } else if (this.element.dataSource === 'sql') {
            this.ifSql();
        } else if (this.element.dataSource === 'api') {
            this.ifStatic();
        } else if (this.element.dataSource === 'public') {
            this.ifStatic();
        }
        this.drawLine();
    },
    methods: {
        registerMaps(str) {
            if (str === 'China') {
                echarts.registerMap('China', chinaJson);
            } else if (str === 'bei_jing') {
                echarts.registerMap('bei_jing', bei_jing);
            } else if (str === 'tian_jin') {
                echarts.registerMap('tian_jin', tian_jin);
            } else if (str === 'he_bei') {
                echarts.registerMap('he_bei', he_bei);
            } else if (str === 'shan_xi') {
                echarts.registerMap('shan_xi', shan_xi);
            } else if (str === 'nei_menggu') {
                echarts.registerMap('nei_menggu', nei_menggu);
            } else if (str === 'liao_ning') {
                echarts.registerMap('liao_ning', liao_ning);
            } else if (str === 'ji_lin') {
                echarts.registerMap('ji_lin', ji_lin);
            } else if (str === 'hei_longjiang') {
                echarts.registerMap('hei_longjiang', hei_longjiang);
            } else if (str === 'shanghai') {
                echarts.registerMap('shanghai', shanghai);
            } else if (str === 'jiang_su') {
                echarts.registerMap('jiang_su', jiang_su);
            } else if (str === 'zhe_jiang') {
                echarts.registerMap('zhe_jiang', zhe_jiang);
            } else if (str === 'an_hui') {
                echarts.registerMap('an_hui', an_hui);
            } else if (str === 'fu_jian') {
                echarts.registerMap('fu_jian', fu_jian);
            } else if (str === 'jiang_xi') {
                echarts.registerMap('jiang_xi', jiang_xi);
            } else if (str === 'shang_dong') {
                echarts.registerMap('shang_dong', shang_dong);
            } else if (str === 'he_nan') {
                echarts.registerMap('he_nan', he_nan);
            } else if (str === 'hu_bei') {
                echarts.registerMap('hu_bei', hu_bei);
            } else if (str === 'hu_nan') {
                echarts.registerMap('hu_nan', hu_nan);
            } else if (str === 'guang_dong') {
                echarts.registerMap('guang_dong', guang_dong);
            } else if (str === 'guang_xi') {
                echarts.registerMap('guang_xi', guang_xi);
            } else if (str === 'hai_nan') {
                echarts.registerMap('hai_nan', hai_nan);
            } else if (str === 'chong_qing') {
                echarts.registerMap('chong_qing', chong_qing);
            } else if (str === 'si_chuang') {
                echarts.registerMap('si_chuang', si_chuang);
            } else if (str === 'gui_zhou') {
                echarts.registerMap('gui_zhou', gui_zhou);
            } else if (str === 'yu_nan') {
                echarts.registerMap('yu_nan', yu_nan);
            } else if (str === 'xi_zang') {
                echarts.registerMap('xi_zang', xi_zang);
            } else if (str === 'shan3_xi') {
                echarts.registerMap('shan3_xi', shan3_xi);
            } else if (str === 'gan_su') {
                echarts.registerMap('gan_su', gan_su);
            } else if (str === 'qinghai') {
                echarts.registerMap('qinghai', qinghai);
            } else if (str === 'ning_xia') {
                echarts.registerMap('ning_xia', ning_xia);
            } else if (str === 'xin_jiang') {
                echarts.registerMap('xin_jiang', xin_jiang);
            } else if (str === 'tai_wan') {
                echarts.registerMap('tai_wan', tai_wan);
            } else if (str === 'xiang_gang') {
                echarts.registerMap('xiang_gang', xiang_gang);
            } else if (str === 'ao_men') {
                echarts.registerMap('ao_men', ao_men);
            }
            // eval('console.log(this)');
            //
            // echarts.registerMap('tian_jin', tian_jin);
            // echarts.registerMap('shan_xi', shan_xi);
            // echarts.registerMap('nei_menggu', nei_menggu);
        },
        registerAllMaps() {

            echarts.registerMap('China', chinaJson);

            // echarts.registerMap('bei_jing', bei_jing);
            echarts.registerMap('北京市', bei_jing);

            // echarts.registerMap('tian_jin', tian_jin);
            echarts.registerMap('天津市', tian_jin);

            echarts.registerMap('河北省', he_bei);

            echarts.registerMap('山西省', shan_xi);

            echarts.registerMap('内蒙古自治区', nei_menggu);

            echarts.registerMap('辽宁省', liao_ning);

            echarts.registerMap('吉林省', ji_lin);

            echarts.registerMap('黑龙江省', hei_longjiang);

            echarts.registerMap('上海市', shanghai);

            echarts.registerMap('江苏省', jiang_su);

            echarts.registerMap('浙江省', zhe_jiang);

            echarts.registerMap('安徽省', an_hui);

            echarts.registerMap('福建省', fu_jian);

            echarts.registerMap('江西省', jiang_xi);

            echarts.registerMap('山东省', shang_dong);

            echarts.registerMap('河南省', he_nan);

            echarts.registerMap('湖北省', hu_bei);

            echarts.registerMap('湖南省', hu_nan);

            echarts.registerMap('广东省', guang_dong);

            echarts.registerMap('广西壮族自治区', guang_xi);

            echarts.registerMap('海南省', hai_nan);

            echarts.registerMap('重庆市', chong_qing);

            echarts.registerMap('四川省', si_chuang);

            echarts.registerMap('贵州省', gui_zhou);

            echarts.registerMap('云南省', yu_nan);

            echarts.registerMap('西藏自治区', xi_zang);

            echarts.registerMap('陕西省', shan3_xi);

            echarts.registerMap('甘肃省', gan_su);

            echarts.registerMap('青海省', qinghai);

            echarts.registerMap('宁夏回族自治区', ning_xia);

            echarts.registerMap('新疆维吾尔自治区', xin_jiang);

            echarts.registerMap('台湾省', tai_wan);

            echarts.registerMap('香港特别行政区', xiang_gang);

            echarts.registerMap('澳门特别行政区', ao_men);

        },
        // 筛选系列名对应的 散图数据
        formatOriginScatter(originData) {
            let result = [];
            //
            result = originData.map(item => {
                let obj = {};
                this.reflection.forEach(ele => {
                    obj[ele.sourceField] = item[ele.reflectionField];
                });

                // obj 的 键名 为源字段
                return {
                    name: obj.name,
                    seriesName: obj.seriesName,
                    // 经度 纬度 值
                    value: [obj.longitude, obj.latitude, obj.value, item],
                };
            });

            return result;
        },
        initSeriesData() {
            // 散点图需要的直接数据
            let data1 = [
                {
                    name: '海门',
                    seriesName: 'series1',
                    x: 121.95,
                    y: 31.89,
                    value: 200,
                },
            ];

            let tempData = [
                {
                    name: '海门',
                    value: [121.95, 31.89, 200], // 前两个是坐标
                },
            ];
            let _self = this;

            if (this.propValue.chartOption.series) {
                this.propValue.chartOption.series.forEach(ele => {
                    ele.data = _self.formatOriginScatter(_self.element.FStaticSource.data).filter(item => {
                        // 系列 过滤
                        console.log(item, ele.name);
                        return item.seriesName === ele.name;
                    });
                });
                let series1 = {
                    name: 'series1',
                    type: 'scatter', // 一般散点图
                    // type: 'effectScatter',  // 气泡散点图
                    coordinateSystem: 'geo',
                    // data: _self.convertData(_self.mapData),
                    data: tempData,
                    // 编码映射
                    encode: {
                        label: 'name',
                        value: 2, //  2  比较奇怪
                    },
                    symbolSize: 20,
                    // symbolSize: (val) => {
                    //     // console.log(val);
                    //     // if (_self.)
                    //     // return val[2] / 10;
                    //     return  40;
                    // },
                    // 标记类型
                    symbol: 'circle',
                    label: {
                        show: true,
                        // https://echarts.apache.org/zh/option.html#series-scatter.label.formatter
                        formatter: '{b}{c}',
                        position: 'right',
                    },
                    // 可以调整气泡颜色
                    itemStyle: {
                        color: '#ddb926',
                    },
                    // xAxisId: 1,
                    // yAxisId: 1,
                };
            }
        },
        // 地图上的线图
        convertToLineData(data, gps) {
            let res = [];
            for (let i = 0; i < data.length; i++) {
                let dataItem = data[i];
                let toCoord = this.geoCoordMap[dataItem.name];
                let fromCoord = gps; //郑州
                //  var toCoord = geoGps[Math.random()*3];
                if (fromCoord && toCoord) {
                    if (t === 1) {
                        res.push([
                            {
                                coord: toCoord,
                            },
                            {
                                coord: fromCoord,
                                value: dataItem.value,
                            },
                        ]);
                    } else {
                        res.push([
                            {
                                coord: fromCoord,
                                value: dataItem.value,
                            },
                            {
                                coord: toCoord,
                            },
                        ]);
                    }
                }
            }
            if (t === 0) {
                t = 1;
            } else {
                t = 0;
            }
            return res;
        },
        //create data for scatter type
        convertData(data) {
            let res = [];
            for (let i = 0; i < data.length; i++) {
                let geoCoord = this.geoCoordMap[data[i].name];
                if (geoCoord) {
                    res.push({
                        name: data[i].name,
                        value: geoCoord.concat(data[i].value),
                    });
                }
            }
            return res;
        },
        getData() {
            if (this.element.dataSource === 'billform') {
                this.ifBillForm();
            } else if (this.element.dataSource === 'static') {
                this.ifStatic();
            } else if (this.element.dataSource === 'sql') {
                this.ifSql();
            } else if (this.element.dataSource === 'api') {
                this.ifApi();
            } else if (this.element.dataSource === 'public') {
                this.ifPublic();
            }

            this.seriesObjChange();
        },
        ifStatic() {
            let _self = this;
            let staticData = _self.element.FStaticSource.data;
            if (this.propValue.chartOption.series && staticData && staticData.length > 0) {
                let mapData = _self.formatOriginScatter(staticData.filter((item) => {
                    return item.type !== 'area'; // area or point
                }));
                let areaData = staticData.filter((item) => {
                    return item.type === 'area'; // area or point
                });
                // 由数据改变区域颜色
                this.changeRegions(areaData);
                this.propValue.chartOption.series.forEach(ele => {
                    // 数据不从接口拿
                    // map test data map test data
                    if (ele.type !== 'map') {
                        ele.data = mapData.filter(item => {
                            // 系列 过滤
                            // console.log(item, ele.name);
                            return item.seriesName === ele.seriesName;
                        });
                    } else if (ele.type === 'map') {
                        // debugger
                        ele.data = [];
                        mapData.forEach((item) => {
                            if (item.seriesName === ele.seriesName) {
                                // todo
                                ele.data.push({
                                    name: item.name,
                                    value: item.value[2]
                                });
                            }
                        });
                    }
                });
            }
        },
        ifBillForm() {
            let _self = this;
            if (this.dataset) {
                this.dataset.forEach(item => {
                    if (item.FDETAILID === _self.element.FDETAILID) {
                        _self.element.FBillFormSource.data = item.Data;
                    }
                });
            }
            let billData = _self.element.FBillFormSource.data;
            if (this.propValue.chartOption.series && billData && billData.length) {
                let mapData = _self.formatOriginScatter(billData.filter((item) => {
                    return item.type !== 'area'; // area or point
                }));

                let areaData = billData.filter((item) => {
                    return item.type === 'area'; // area or point
                });
                // 由数据改变区域颜色
                this.changeRegions(areaData);

                this.propValue.chartOption.series.forEach(ele => {
                    if (ele.type !== 'map') {
                        ele.data = mapData.filter(item => {
                            // 系列 过滤
                            // console.log(item, ele.name);
                            return item.seriesName === ele.seriesName;
                        });
                    } else if (ele.type === 'map') {
                        // debugger
                        ele.data = [];
                        mapData.forEach((item) => {
                            if (item.seriesName === ele.seriesName) {
                                // todo
                                ele.data.push({
                                    name: item.name,
                                    value: item.value[2]
                                });
                            }
                        });
                    }
                });
            }
        },
        ifSql() {
            let _self = this;

            if (this.dataset) {
                this.dataset.forEach(item => {
                    if (item.FDETAILID === _self.element.FDETAILID) {
                        _self.element.FSqlSource.data = item.Data;
                    }
                });
            }

            let sqlData = _self.element.FSqlSource.data;
            if (this.propValue.chartOption.series && sqlData && sqlData.length > 0) {
                let mapData = _self.formatOriginScatter(sqlData.filter((item) => {
                    return item.type !== 'area'; // area or point
                }));
                let areaData = sqlData.filter((item) => {
                    return item.type === 'area'; // area or point
                });

                // 由数据改变区域颜色
                this.changeRegions(areaData);

                this.propValue.chartOption.series.forEach(ele => {
                    if (ele.type !== 'map') {
                        ele.data = mapData.filter(item => {
                            // 系列 过滤
                            // console.log(item, ele.name);
                            return item.seriesName === ele.seriesName;
                        });
                    } else if (ele.type === 'map') {
                        // debugger
                        console.log(mapData, 'mapData', ele.data);
                        ele.data = [];
                        mapData.forEach((item) => {
                            if (item.seriesName === ele.seriesName) {
                                // todo
                                ele.data.push({
                                    name: item.name,
                                    value: item.value[2]
                                });
                            }
                        });
                    }
                });
            }
        },
        ifApi() {
            let _self = this;
            if (this.dataset) {
                this.dataset.forEach(item => {
                    if (item.FDETAILID === _self.element.FDETAILID) {
                        _self.element.FDATASOURCE4.data = item.Data;
                    }
                });
            }
            if (this.propValue.chartOption.series && _self.element.FDATASOURCE4.data.length) {
                this.propValue.chartOption.series.forEach(ele => {
                    if (ele.type !== 'map') {
                        ele.data = mapData.filter(item => {
                            // 系列 过滤
                            // console.log(item, ele.name);
                            return item.seriesName === ele.seriesName;
                        });
                    } else if (ele.type === 'map') {
                        // debugger
                        ele.data = [];
                        mapData.forEach((item) => {
                            if (item.seriesName === ele.seriesName) {
                                // todo
                                ele.data.push({
                                    name: item.name,
                                    value: item.value[2]
                                });
                            }
                        });
                    }
                });
            }
        },
        ifPublic() {
            let _self = this;
            if (this.dataset) {
                this.dataset.forEach(item => {
                    if (item.FDETAILID === _self.element.FDETAILID) {
                        _self.element.FPublicSource.data = item.Data;
                    }
                });
            }
            if (this.propValue.chartOption.series && _self.element.FPublicSource.data.length) {
                this.propValue.chartOption.series.forEach(ele => {
                    if (ele.type !== 'map') {
                        ele.data = mapData.filter(item => {
                            // 系列 过滤
                            // console.log(item, ele.name);
                            return item.seriesName === ele.seriesName;
                        });
                    } else if (ele.type === 'map') {
                        // debugger
                        ele.data = [];
                        mapData.forEach((item) => {
                            if (item.seriesName === ele.seriesName) {
                                // todo
                                ele.data.push({
                                    name: item.name,
                                    value: item.value[2]
                                });
                            }
                        });
                    }
                });
            }
        },
        /**
         * 处理 option.geo.regions 数据
         */
        changeRegions(data) {
            // todo 待处理changeRegions
            return
            let obj = {};
            this.reflection.forEach(ele => {
                obj[ele.sourceField] = ele.reflectionField;
            });

            let areaNames = [];

            this.propValue.chartOption.geo.regions1.forEach((item) => {
                areaNames.push(item.name);
            });

            this.propValue.chartOption.geo.regions= [...this.propValue.chartOption.geo.regions1];
            data.forEach(item => {
                let name = item[obj.name];
                let color = item[obj.color];
                let tooltipFormatter = this.propValue.chartOption.geo.tooltipFormatterInfo | '{a}:{b}';
                if (areaNames.indexOf(name) === -1) {
                    this.propValue.chartOption.geo.regions.push({
                        // 也可以传更多的参数
                        name: name,
                        itemStyle: {
                            areaColor: color,
                            borderColor: 'none',
                        },
                        label: {
                            show: false,
                            // formatter: '{b}1'
                        },
                        tooltip: {
                            show: true,
                            formatter: tooltipFormatter.replace('{b}', item[obj.value]),
                        }
                    });

                    areaNames.push(name);
                }

            });
        },
        /**
         * 处理 series[index].symbolSize 的 函数实现; int or function
         */
        seriesObjChange() {
            // val[2] 是数值
            // return
            let config = this.propValue.valueConfig;
            this.propValue.chartOption.series.forEach(item => {
                // 自定义形状大小

                if (item.type !== 'map'){
                    if (this.propValue.Finance) {
                        let _self = this;
                        // item.symbolSize
                        item.symbolSize = function (val) {
                            // console.log(val);
                            if (val[3].name1 === _self.rightInfo.cityName) {
                                return item.symbolSizeDefault + 10;
                            } else {
                                return item.symbolSizeDefault;
                            }
                        };
                    } else {
                        item.symbolSize = function (val) {
                            for (let i in config) {
                                if (config[i].type === 'value' && val[2] < config[i].max && val[2] > config[i].min && config[i].content) {
                                    return Number(config[i].content);
                                }
                            }

                            if (item.symbolType === 'function') {
                                if (!item.symbolSizeProportion) {
                                    item.symbolSizeProportion = 1;
                                }

                                return val[2] / item.symbolSizeProportion;
                            } else {
                                return item.symbolSizeDefault;
                            }
                        };
                    }

                    // 自定义形状
                    item.symbol = function (val) {
                        // return 'image://' + item.symbolImage;
                        for (let i in config) {
                            if (config[i].type === 'shape' && val[2] < config[i].max && val[2] > config[i].min && config[i].content) {
                                return config[i].content;
                            }
                        }
                        // 不匹配 返回默认配置
                        return item.symbolDefault;
                    };

                    // 自定义颜色; 回调中 val 的内容和以上不一样
                    item.itemStyle.color = function (val) {
                        // return 'image://' + item.symbolImage;
                        for (let i in config) {
                            if (
                                config[i].type === 'color' &&
                                val.value[2] < config[i].max &&
                                val.value[2] > config[i].min &&
                                config[i].content
                            ) {
                                console.log(config[i].content);

                                return config[i].content;
                            }
                        }
                        // 不匹配 返回默认配置
                        return item.itemStyle.colorDefault;
                    };
                }

            });
        },
        resizeChart() {
            this.myChart.resize();
        },
        // 更新 chart 的option
        drawLine() {
            // return
            this.myChart.setOption(this.propValue.chartOption, true);
            console.log(this.propValue.chartOption.series[0].data);
        },
    },
    watch: {
        // 千万要注意避免死循环, watch 处理变化的逻辑里不要再改变自己了
        /**
         * 数据变化后, 重绘图表
         */
        'element.FStaticSource': {
            handler() {
                this.getData();
                this.drawLine();
            },
            immediate: false,
            deep: true,
        },
        'element.FBillFormSource': {
            handler() {
                this.getData();
                this.drawLine();
            },
            immediate: false,
            deep: true,
        },
        'element.FSqlSource': {
            handler() {
                this.getData();
                this.drawLine();
            },
            immediate: false,
            deep: true,
        },
        'element.FDATASOURCE4': {
            handler() {
                this.getData();
                this.drawLine();
            },
            immediate: false,
            deep: true,
        },
        'propValue.chartOption.series': {
            handler() {
                this.drawLine();
            },
            immediate: false,
            deep: true,
        },
        'propValue.chartOption.geo': {
            handler() {
                this.registerMaps();
                this.drawLine();
            },
            immediate: false,
            deep: true,
        },
        'propValue.chartOption.legend': {
            handler() {
                this.drawLine();
            },
            immediate: false,
            deep: true,
        },
        'propValue.chartOption.visualMap': {
            handler() {
                this.drawLine();
            },
            immediate: false,
            deep: true,
        },
        'element.style': {
            handler() {
                this.resizeChart();
            },
            immediate: false,
            deep: true,
        },
    },
    computed: {
        dataset() {
            return this.$store.state.dataset; // 总的数据
        },
        // eslint-disable-next-line vue/return-in-computed-property
        reflection() {
            if (this.element.dataSource === 'billform') {
                return this.element.FBillFormSource.reflection;
            } else if (this.element.dataSource === 'static') {
                return this.element.FStaticSource.reflection;
            } else if (this.element.dataSource === 'sql') {
                return this.element.FSqlSource.reflection;
            } else if (this.element.dataSource === 'api') {
                return this.element.FDATASOURCE4.reflection;
            } else if (this.element.dataSource === 'public') {
                return this.element.FPublicSource.reflection;
            }
        },
    },
};
</script>
